/**
 * @worker
 * @return {Uint16Array}
 */
export default function () {
	var round = Math.round;

	self.onmessage = function (e) {
		var msgData = e.data,
			columns = msgData.columns,
			columnCount = columns.length,
			rows = msgData.rows,
			rowCount = rows.length,
			totalColumns = msgData.totalColumns,
			totalRows = msgData.totalRows,
			cells = msgData.cells,
			cellCount = 0,
			index = 0,
			c,
			col,
			cols,
			i,
			key,
			row,
			x,
			y;

		// Do not include cells within selected columns/rows
		for (key in cells) {
			if (cells.hasOwnProperty(key)) {
				row = parseInt(key);
				if (rows.indexOf(row) < 0) {
					cols = cells[key];
					for (i = 0, c = cols.length; i < c; i++) {
						if (columns.indexOf(cols[i]) < 0) {
							cellCount++;
						}
					}
				}
			}
		}

		// Total cells that will be collected
		var totalPoints =
			(cellCount +
				columnCount * totalRows +
				rowCount * totalColumns -
				columnCount * rowCount) *
			4;

		if (msgData.all) {
			totalPoints = totalRows * totalColumns * 4;
		}

		// A buffer (twice the cell count) and a typed array are faster than
		// an array in the same manner (where every 2 values are a pair)
		// Not to mention faster than a multidimaensional array or array of objects
		// Since this is a Uint16 we support 65536 rows and columns - but you would
		// crash the browser long before you hit this.
		//
		// TODO: Convert to 32 if this should not suffice and we live in a future
		// where memory is not a concern.
		var buf = new ArrayBuffer(totalPoints),
			points = new Uint16Array(buf);

		// Just fire off a message after every other row
		// This cuts down on execution time while allowing the UI to update progress visually
		// Sending any messages at all will increase the execution time of this worker but
		// actual feedback is better than simulated, so it is a trade off.
		// You cannot send any messages to this worker to explicitely check progress because
		// though this runs in its own thread, it still blocks that thread while working
		// so no messages will get out before it is complete
		// Not knowing data size or system capability I think a trade off in a little extra time
		// and being able to display real progress is preferrable

		// All cells selected
		if (msgData.all) {
			for (y = 0; y < totalRows; y++) {
				row = y;
				for (x = 0; x < totalColumns; x++) {
					points[index] = x;
					points[index + 1] = row;
					index += 2;
				}
				y % 2 &&
					self.postMessage({progress: round((index / totalPoints) * 100)});
			}
		}
		// Partial selection
		else {
			// First columns
			if (columnCount) {
				for (x = 0; x < columnCount; x++) {
					col = columns[x];
					for (y = 0; y < totalRows; y++) {
						row = y;
						points[index] = col;
						points[index + 1] = row;
						index += 2;
					}
					x % 2 &&
						self.postMessage({progress: round((index / totalPoints) * 100)});
				}
			}

			// Then rows
			if (rowCount) {
				for (y = 0; y < rowCount; y++) {
					row = rows[y];
					for (x = 0; x < totalColumns; x++) {
						col = x;
						if (columns.indexOf(x) < 0) {
							points[index] = col;
							points[index + 1] = row;
							index += 2;
						}
					}
					y % 2 &&
						self.postMessage({progress: round((index / totalPoints) * 100)});
				}
			}

			// And lastly, loose cell
			if (cellCount) {
				for (key in cells) {
					if (cells.hasOwnProperty(key)) {
						row = parseInt(key);
						if (rows.indexOf(row) < 0) {
							cols = cells[key];
							for (i = 0, c = cols.length; i < c; i++) {
								col = cols[i];
								if (columns.indexOf(col) < 0) {
									points[index] = col;
									points[index + 1] = row;
									index += 2;
								}
							}
						}
						self.postMessage({progress: round((index / totalPoints) * 100)});
					}
				}
			}
		}

		self.postMessage({progress: 100, points: points}, [points.buffer]);
		self.close();
	};
}
